/**
 * 提醒铃声。
 *
 * 手机浏览器普遍禁止「页面从没被碰过就出声」（自动播放策略）。
 * 原来的写法是每次响铃才 new 一个 AudioContext —— 而在到点提醒这种
 * 非用户点击的场景下创建出来的 AudioContext 会是 suspended 状态，
 * 声音被静默丢弃，表现就是「铃声开关明明开着却没响过」。
 *
 * 所以这里改为：保留一个常驻的上下文，并在用户第一次触摸屏幕时把它唤醒。
 */

let audioCtx = null;

function getContext() {
  if (typeof window === 'undefined') return null;
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) return null;
  if (!audioCtx) {
    try {
      audioCtx = new Ctx();
    } catch (e) {
      return null;
    }
  }
  return audioCtx;
}

/**
 * 在用户手势里调用，把音频上下文唤醒。
 * 之后即便到了非手势触发的到点提醒，也能正常出声。
 */
export function unlockAudio() {
  const ctx = getContext();
  if (ctx && ctx.state === 'suspended') {
    try {
      const p = ctx.resume();
      if (p && p.catch) p.catch(() => {});
    } catch (e) {
      // 唤醒失败不阻断流程，到点时还会再试一次
    }
  }
}

/**
 * 播放提示音。
 *
 * @param {number} times 连响几声，用于「重复提醒」形成更明显的节奏
 */
export function playAlertBeep(times = 1) {
  const ctx = getContext();
  if (!ctx) return;
  // 非手势场景下 resume 可能被拒，试一次；失败就放弃，不影响弹窗
  if (ctx.state === 'suspended') {
    try {
      const p = ctx.resume();
      if (p && p.catch) p.catch(() => {});
    } catch (e) {
      // 忽略
    }
  }
  const count = Math.max(1, Math.min(3, times));
  for (let i = 0; i < count; i += 1) {
    const startAt = ctx.currentTime + i * 0.45;
    try {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.type = 'sine';
      osc.frequency.value = 880;
      // 用极短的正值起音，避免爆音；exponentialRamp 不接受 0
      gain.gain.setValueAtTime(0.0001, startAt);
      gain.gain.exponentialRampToValueAtTime(0.35, startAt + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, startAt + 0.32);
      osc.start(startAt);
      osc.stop(startAt + 0.34);
    } catch (e) {
      // 单声失败不影响其余
    }
  }
}
